import NoOfFacingsByRetailer from "./NoOfFacingsByRetailer";
export default NoOfFacingsByRetailer;
